<template>
  <b-container>
    <b-row>
      <b-col>
        <h4>{{ formTitle }}</h4>
        <p class="error">
          {{ formSubTitle }}
        </p>
        <b-modal id="user-failure-modal" title="REGISTRATION ERROR">
          <p class="error">
            Something went wrong! Please try again, or contact your site's
            administrator
          </p>
        </b-modal>
        <b-modal id="user-success-modal" title="Registered User Info">
          <p>
            Please write this information down in a safe space; you cannot
            change a user's password!
          </p>
          <p class="my-4">
            <span>Email: </span>
            <span class="bi">{{ email }}</span>
          </p>
          <p class="my-4">
            <span>Password:</span>
            <span class="bi">{{ password }}</span>
          </p>
        </b-modal>
        <b-form-group>
          <div id="username" class="mt-4">
            <label for="username">User's name:</label>
            <b-form-input v-model="user_name" type="text" name="username" />
          </div>
          <div id="email" class="mt-4">
            <label for="email">Email:</label>
            <b-form-input
              v-model="email"
              type="email"
              name="email"
              v-validate="'required|email'"
              :class="{ input: true, 'is-danger': errors.has('email') }"
            />
            <p v-if="errors.has('email')" class="error help is-danger">
              {{ errors.first('email') }}
            </p>
          </div>
          <div id="password" class="mt-4">
            <label for="password">Password:</label>
            <b-form-input
              type="password"
              v-model="password"
              name="password"
              placeholder="password"
            />
          </div>
          <p v-if="password.length < 6" class="error">
            Your password must be longer than 5 characters
          </p>
          <div id="confirm" class="mt-4">
            <label for="confirm">Confirm password:</label>
            <b-form-input
              type="password"
              v-model="confirm"
              name="confirm"
              placeholder="Confirm password"
            />
          </div>
          <p v-if="password !== confirm" class="error">
            Your passwords do not match
          </p>
          <p v-if="confirm.length < 6" class="error">
            Your password must be longer than 5 characters
          </p>
        </b-form-group>

         <div v-if="userType == 'SRC'" class="mb-3">
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value=true
            unchecked-value=false
          >
            Add Cluster teams to SRC
          </b-form-checkbox>
          <div v-if="status=='true'" class="mt-4">
              <cluster-teams></cluster-teams>
          </div>
          
        </div>

        <b-button variant="primary" :disabled="isDisabled" @click="createUser"
          >Create User</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AuthService from '../services/AuthService';
import ClusterTeams from '../components/ClusterTeams';
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'UserForm',
  props: ['userType'],
  components:{ClusterTeams},
  data() {
    return {
      user_name: '',
      email: '',
      password: '',
      confirm: '',
      formTitle:'',
      formSubTitle:'',
      status: false
    };
  },
  methods: {
    async createUser() {
      // console.log(this.teams);
      // return;
      const confirmAdd = confirm(
        `Are you sure you want to make ${this.user_name} an ${this.userType}?`
      );
      if (!confirmAdd) return;
      const user = {
        uuid: this.uuid,
        user_name: this.user_name,
        email: this.email,
        admin: true,
        password: this.password,
        user_type: this.userType.toLowerCase(),
        teamIds: this.getTeamIds
      };
      
      const res = await AuthService.createUser(user).catch(err => {
        this.$bvModal.show('user-failure-modal');
        console.log(err);
      });
      this.$bvModal.show('user-success-modal');
      this.user_name = '';
      this.email = '';
      this.password = '';
      this.confirm = '';
    },
    userSwitch(){
      if(this.userType =="Administrator"){
        this.formTitle = "USE THIS FORM TO CREATE ADMINISTRATIVE USERS ONLY!";
        this.formSubTitle = "Administrative users have full website access, but do not have a linked trainer account for use with the app";
      }else{
        this.formTitle = "USE THIS FORM TO CREATE SENIOR REGIONAL COORDINATORS!";
        this.formSubTitle = "Senior regional coordinator users have website access to the cluster under them, but do not have a linked trainer account for use with the app";
      }
    }
  },
  computed: {
     ...mapGetters({
      getTeamIds:"cluster/getTeamIds",
    }),
    
    isDisabled() {
      if (
        this.password.length > 5 &&
        this.confirm.length > 5 &&
        this.password === this.confirm
      ) {
        return false;
      }
      return true;
    },
  },
  mounted(){
    this.userSwitch()
  }
};
</script>

<style scoped>
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
.bi {
  font-weight: bold;
  font-style: italic;
}
</style>
